
import { PricingFeature } from "./PricingFeaturesList";

export const DEFAULT_PRICING_FEATURES: PricingFeature[] = [
  { 
    name: "Idea Generation", 
    free: "Up to 15 Creative Craft Ideas", 
    monthly: "Up to 150 Creative Craft Ideas monthly",
    yearly: "Up to 150 Creative Craft Ideas monthly",
    test: "Unlimited analysis"
  },
  { 
    name: "History Storage", 
    free: "24 hours", 
    monthly: "Unlimited",
    yearly: "Unlimited",
    test: "Unlimited" 
  },
  {
    name: "Crafty Support",
    free: "Email Support",
    monthly: "Priority Support",
    yearly: "Priority Support",
    test: "Email & chat"
  }
];
